import { $axiosBilling } from '@/api/$axios';

const cfg = { skipBusinessProfileId: true };

/**
 * Convert a numeric business profile ID to the external_id format used by the billing engine.
 */
export const toExternalId = (bpId) => `bp_${bpId}`;

/**
 * Idempotent customer registration.
 * Creates Stripe customer + trial, or returns existing mapping.
 * Owner email is resolved server-side from DB.
 */
export const registerCustomer = (externalId) =>
  $axiosBilling.post('/customers/register', { external_id: externalId }, cfg);

/**
 * Get billing status for a business profile.
 * Returns subscription, trial, or no_subscription status.
 */
export const getBillingStatus = (externalId) =>
  $axiosBilling.get(`/status/${externalId}`, cfg);

/**
 * Create a Stripe Checkout session and return the checkout URL.
 */
export const createCheckout = (externalId, planId) =>
  $axiosBilling.post('/checkout', { external_id: externalId, plan_id: planId }, cfg);

/**
 * Add an add-on to the current subscription.
 */
export const addAddOn = (externalId, featureId, quantity = 1) =>
  $axiosBilling.post('/add-ons', { external_id: externalId, feature_id: featureId, quantity }, cfg);

/**
 * Update an existing add-on's quantity.
 */
export const updateAddOn = (subscriptionItemId, quantity) =>
  $axiosBilling.patch(`/add-ons/${subscriptionItemId}`, { quantity }, cfg);

/**
 * Remove an add-on subscription item.
 */
export const removeAddOn = (subscriptionItemId) =>
  $axiosBilling.delete(`/add-ons/${subscriptionItemId}`, cfg);

/**
 * Schedule subscription cancellation at period end.
 */
export const cancelSubscription = (externalId) =>
  $axiosBilling.post('/subscriptions/cancel', { external_id: externalId }, cfg);

/**
 * Undo pending subscription cancellation.
 */
export const resumeSubscription = (externalId) =>
  $axiosBilling.post('/subscriptions/resume', { external_id: externalId }, cfg);

/**
 * Get billing history (invoices, payments, charges, disputes).
 * external_id is derived server-side from the JWT token.
 */
export const getBillingHistory = (limit = 50) =>
  $axiosBilling.get('/billing-history', { ...cfg, params: { limit } });

/**
 * Create a Stripe Billing Portal session for updating payment method.
 * Returns { portal_url } — redirect user to this URL.
 */
export const createBillingPortal = (externalId) =>
  $axiosBilling.post('/billing-portal', { external_id: externalId }, cfg);
